var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { KtsReportService } from './report.service';
import { AlertModalService } from '../../../../component/alertmodal/alertmodal.service';
import { ApiService } from '../../../../service/api.service';
var KtsReportFileComponent = /** @class */ (function (_super) {
    __extends(KtsReportFileComponent, _super);
    function KtsReportFileComponent(router, route, logger, action, message, page, alertModalService, service, api) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.alertModalService = alertModalService;
        _this.service = service;
        _this.api = api;
        _this.changeFiles = new EventEmitter();
        _this.files = [];
        _this.fileSetting = false;
        _this.fileLength = 0;
        _this.type = [];
        _this.items = {};
        _this.toggles = {};
        _this.image = '';
        return _this;
    }
    KtsReportFileComponent.prototype.ngOnChanges = function (changes) {
        if (this.fileSetting) {
            this.setItems();
        }
    };
    KtsReportFileComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    KtsReportFileComponent.prototype.ngAfterViewInit = function () {
        this.modalImage = this.remodalImageElement.nativeElement;
        this.remodalImage = $(this.modalImage).remodal({ hashTracking: false });
    };
    KtsReportFileComponent.prototype.switchToggle = function (type) {
        this.toggles[type] = !this.toggles[type];
    };
    KtsReportFileComponent.prototype.setItems = function () {
        this.items = {};
        var files = JSOG.parse(JSON.stringify(this.files));
        for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
            var file = files_1[_i];
            if (typeof this.items[file.type] === 'undefined') {
                this.items[file.type] = [];
            }
            this.items[file.type].push(file);
        }
    };
    KtsReportFileComponent.prototype.setUnsubscribe = function () {
        this.refSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    KtsReportFileComponent.prototype.onEvent = function (e1, e2, r) {
        if (e2 === 'delete') {
            // 削除ボタンクリック時に画像ファイルを削除する
            this.deleteType = r.type;
            this.deleteIndex = r.index;
            this.alertModalService.open({
                type: 'warn',
                message: this.msgSnapshot['Modal.delete.confirm'],
                buttons: [{
                        class: 'ok',
                        event: this.componentName + '#delete',
                        caption: this.msgSnapshot['Modal.button.delete']
                    }, {
                        class: 'cancel',
                        event: this.componentName + '#delete#cancel',
                        caption: this.msgSnapshot['Modal.button.cancel']
                    }]
            });
        }
        else if (e2 === 'image') {
            this.image = this.items[r.type][r.index].file;
            this.remodalImage.open();
        }
        else if (e2 === 'imageClose') {
            this.image = '';
        }
        this.setCompRec();
    };
    KtsReportFileComponent.prototype.onEventSubscribe = function (e) {
        if (e === this.componentName + '#delete') {
            var baseUrl = '/v1/gen/partner-construction-file-api';
            this.service.setBaseUrl(baseUrl);
            var deleteFileId = this.items[this.deleteType][this.deleteIndex].id;
            this.service.deleteRecord(deleteFileId).subscribe();
            this.items[this.deleteType].splice(this.deleteIndex, 1);
            this.setCompRec(deleteFileId);
        }
    };
    KtsReportFileComponent.prototype.onChange = function (e, r) {
        this.items[r.type][r.index][e.key] = e.val;
        this.setCompRec();
    };
    KtsReportFileComponent.prototype.setCompRec = function (deleteFileId) {
        if (deleteFileId === void 0) { deleteFileId = null; }
        var items = [];
        for (var _i = 0, _a = this.type; _i < _a.length; _i++) {
            var ty = _a[_i];
            if (typeof this.items[ty.code] === 'undefined') {
                continue;
            }
            for (var _b = 0, _c = this.items[ty.code]; _b < _c.length; _b++) {
                var item = _c[_b];
                items.push(item);
            }
        }
        this.changeFiles.emit({ key: 'construction_file', val: items, deleteFileId: deleteFileId });
    };
    KtsReportFileComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if ($(this.modalImage).parent().hasClass('remodal-wrapper')) {
            this.remodalImage.destroy();
        }
    };
    KtsReportFileComponent.prototype.toDownloadUrl = function (item) {
        return this.api.makeUrl("/v1/download/excel/construction-file/" + item.id);
    };
    KtsReportFileComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-report-file',
                    template: "<p class=\"formLabelText\">{{ (msg | async)['au.COMPONENT.KtsReportComponent.label.photo'] }}</p>\n<div *ngFor=\"let ty of type\" class=\"row -m-1\">\n  <div class=\"col-sm-12\">\n    <div class=\"filter\">\n      <p class=\"filter_trigger\">\n        <span [class.open]=\"toggles[ty.code]\" (click)=\"switchToggle(ty.code)\">{{ ty.display }}({{ items[ty.code] ? items[ty.code].length : 0 }})</span>\n      </p>\n      <div class=\"filter_property_toggle -m-1\" [style.display]=\"toggles[ty.code] ? 'block': 'none'\">\n        <p *ngIf=\"!items[ty.code] || items[ty.code].length === 0\">{{ (msg | async)['au.COMPONENT.KtsReportComponent.label.not_registered'] }}</p>\n        <div class=\"row\">\n          <div *ngFor=\"let item of items[ty.code]; let index = index;\" class=\"col-sm-6\">\n            <ul class=\"form form-campaign -mr-2\">\n              <li class=\"stageFlowPane\">\n                <div class=\"stageFlowPane_border\">\n                  <!--<p><a class=\"deleteBtn\" href=\"javascript:void(0);\" (click)=\"onEvent($event, 'delete', {type: ty.code, index: index})\"></a></p>-->\n                  <dl class=\"form -m-1\">\n                    <dd class=\"form_dd\">\n                      <ul>\n                        <li class=\"form_li\">\n                          <columngroup [componentName]=\"componentName + '#' + ty.code\" [index]=\"index\" [key]=\"'form'\" [col]=\"{\n                            key: 'new_type',\n                            controlType: 'select',\n                            required: true,\n                            params: {options: type}\n                          }\" [val]=\"item\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, {type: ty.code, index: index})\"></columngroup>\n                        </li>\n                      </ul>\n                    </dd>\n                  </dl>\n                  <dl class=\"form -m-1\">\n                    <dd class=\"form_dd\">\n                      <ul>\n                        <li class=\"form_li\">\n                          <columngroup [componentName]=\"componentName + '#' + ty.code\" [index]=\"index\" [key]=\"'form'\" [col]=\"{\n                            key: 'label',\n                            controlType: 'text',\n                            params: {placeholder: (msg | async)['au.COMPONENT.KtsReportComponent.label.caption']}\n                          }\" [val]=\"item\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, {type: ty.code, index: index})\"></columngroup>\n                        </li>\n                      </ul>\n                    </dd>\n                  </dl>\n                  <dl class=\"form -m-1\">\n                    <dd class=\"form_dd\">\n                      <ul>\n                        <li class=\"form_li form_li-h150\">\n                          <a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'image', {type: ty.code, index: index})\">\n                            <columngroup [componentName]=\"componentName + '#' + ty.code\" [index]=\"index\" [key]=\"'form'\" [col]=\"{\n                              key: 'file',\n                              controlType: 'img',\n                              params: {cache: false, style: {maxHeight: '150px'}}\n                            }\" [val]=\"item\" [msg]=\"(msg | async)\"></columngroup>\n                          </a>\n                        </li>\n                      </ul>\n                    </dd>\n                  </dl>\n                  <dl class=\"form -m-1\">\n                    <dd class=\"form_dd\">\n                      <ul>\n                        <li class=\"form_li\">\n                          <span style=\"font-size: 1.4rem;\">{{ item.file_name }}</span>\n                        </li>\n                      </ul>\n                    </dd>\n                  </dl>\n                  <dl class=\"form -m-1\">\n                    <dd class=\"form_dd\">\n                      <ul>\n                        <li class=\"btns_li\">\n                          <button class=\"btn btn-delete\" type=\"button\" (click)=\"onEvent($event, 'delete', {type: ty.code, index: index})\">\u524A\u9664</button>\n                        </li>\n                        <li class=\"btns_li\">\n                          <kts-column-file-download [componentName]=\"componentName\" [index]=\"index\" [key]=\"'form'\" [col]=\"{\n                            params: {\n                              uuidFilePath: item.file,\n                              fileName: item.file_name,\n                              assets: false,\n                              cache: false\n                            }\n                          }\" [msg]=\"(msg | async)\"></kts-column-file-download>\n                        </li>\n                      </ul>\n                    </dd>\n                  </dl>\n                </div>\n              </li>\n              <li class=\"stageFlowPane\"></li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<!-- remodal -->\n<div class=\"remodal\" id=\"{{ componentName + '#Remodal#image' }}\" #remodalImage>\n  <columngroup *ngIf=\"image\" [key]=\"'form'\" [col]=\"{\n    key: 'image',\n    controlType: 'img',\n    params: {cache: false}\n  }\" [val]=\"{image: image}\" [msg]=\"(msg | async)\"></columngroup>\n  <div class=\"remodal_btns\">\n    <ul class=\"remodal_btns_group\">\n      <li>\n        <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\" (click)=\"onEvent($event, 'imageClose', {type: null, index: null})\">{{ (msg | async)['au.COMPONENTS.modal.button.close'] }}</button>\n      </li>\n    </ul>\n  </div>\n</div>\n<!-- /remodal -->\n"
                }] }
    ];
    /** @nocollapse */
    KtsReportFileComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: AlertModalService },
        { type: KtsReportService },
        { type: ApiService }
    ]; };
    KtsReportFileComponent.propDecorators = {
        changeFiles: [{ type: Output }],
        files: [{ type: Input }],
        fileSetting: [{ type: Input }],
        fileLength: [{ type: Input }],
        type: [{ type: Input }],
        remodalImageElement: [{ type: ViewChild, args: ['remodalImage',] }]
    };
    return KtsReportFileComponent;
}(ContentBaseComponent));
export { KtsReportFileComponent };
//# sourceMappingURL=report-file.component.js.map